import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import General_FAQ_Seo from '../../SEO/General_FAQ_Seo';
import AOS from 'aos';

function GeneralFAQ() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate an asynchronous operation (e.g., fetching data)
    setTimeout(() => {
      setIsLoading(false);
    }, 500); // Simulating a 1-second delay
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 3000,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <div>
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <General_FAQ_Seo />
          <Header />
          {/* Start Page Banner Area */}
          <div className="page-banner-area position-relative overflow-hidden" style={{ backgroundImage: 'url(assets/images/hero/hero-image-2.svg)' }}>
            <div className="container">
              <div className="page-banner-content">
                <h1>General FAQs</h1>
                <ul>
                  <li><NavLink to="/help">Help</NavLink></li>
                  <li>General FAQs</li>
                </ul>
              </div>
            </div>
          </div>
          {/* End Page Banner Area */}
          {/* Start Faq Area */}
          <div className="faq-area two ptb-100">
            <div className="container">
              {/* <div className="section-title" data-aos-delay={100}>
                <span className="sub-title">FAQ</span>
                <h2>Frequently Asked Questions</h2>
              </div> */}
              <div className="faq-content">
                <div className="accordion" id="accordionShould">
                  <div className="accordion-item" data-aos-delay={100}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse20" aria-expanded="false" aria-controls="collapse20">
                      1. Why do you need my documents while registration?
                    </button>
                    <div id="collapse20" className="accordion-collapse collapse show" data-bs-parent="#accordionShould">
                      <div className="accordion-body">
                        <p>
                          We are regulated by Financial Conduct Authority in the UK. It is our legal binding to verify your identity as a UK resident.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" data-aos-delay={200}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse21" aria-expanded="false" aria-controls="collapse21">
                      2. How can I cancel my transfer?
                    </button>
                    <div id="collapse21" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                      <div className="accordion-body">
                        <p>
                          Please call us or email us at earliest possible if you want to cancel your transfer. Transfer paid out to the recipient cannot be cancelled. If you have paid for your transfer and the transfer is not processed yet, then please contact us by phone and we will make necessary arrangements for refunds. We may charge you a small fee as handling/service charge and refund you the balance amount.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" data-aos-delay={300}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse22" aria-expanded="false" aria-controls="collapse22">
                      3. Will I get notifications about Transfer status?
                    </button>
                    <div id="collapse22" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                      <div className="accordion-body">
                        <p>Yes. We send email notifications to keep you informed. You can view the transfer status by signing in into your web account.</p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" data-aos-delay={400}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse23" aria-expanded="false" aria-controls="collapse23">
                      4. How many recipients I can add?
                    </button>
                    <div id="collapse23" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                      <div className="accordion-body">
                        <p>
                          There is no restriction on the number of recipients you may have on your account.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" data-aos-delay={500}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse24" aria-expanded="false" aria-controls="collapse24">
                      5. You asked me to upload one more document; how can I do that?
                    </button>
                    <div id="collapse24" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                      <div className="accordion-body">
                        <p>Please login in to your account and under My Account you will find document section where you can upload the document.</p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" data-aos-delay={600}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse25" aria-expanded="false" aria-controls="collapse25">
                      6. How can I pay for my transfer?
                    </button>
                    <div id="collapse25" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                      <div className="accordion-body">
                        <p>Bank Transfer to our business account and payments made by using credit or debit cards. Bank Transfer is the recommended and preferred method of payment. There may be restrictions on credit and debit card payment as well as there may be a fee charged on top.</p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" data-aos-delay={700}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse26" aria-expanded="false" aria-controls="collapse26">
                      7. Why I received email stating transfer complete, but the money is not with recipient?
                    </button>
                    <div id="collapse26" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                      <div className="accordion-body">
                        <p>Our pay-out partner bank/agent may have completed the transfer process but the recipient's bank would not have displayed it in their account. Please allow couple of hours to be displayed, if the problem persists then please contact our support team. We will make sure money is with your recipient as promised.</p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" data-aos-delay={800}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse27" aria-expanded="false" aria-controls="collapse27">
                      8. Good to know
                    </button>
                    <div id="collapse27" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                      <div className="accordion-body">
                        <ul>
                          <li>Age: 18 years and above</li>
                          <li>We will verify your identity, this will not affect your credit ratings</li>
                          <li>You must be resident of the UK</li>
                          <li>Activation of account will be based on the documents you provide</li>
                          <li>Monthly sending limits may apply</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" data-aos-delay={900}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse28" aria-expanded="false" aria-controls="collapse28">
                      9. Documents Required
                    </button>
                    <div id="collapse28" className="accordion-collapse collapse" data-bs-parent="#accordionShould">
                      <div className="accordion-body">
                        <ul>
                          <li>Photo Identity Proof (Passport, EU Nationality card or UK Driving License).</li>
                          <li>Address Proof (Utility bill, Bank Statement, Council Tax bill not less than 3 months old).</li>
                          <li>Source of funds document.</li>
                          <li>Company Houses Registration (mandatory for Corporate Accounts).</li>
                          <li>Company Address Proof (mandatory for Corporate Accounts).</li>
                          <li>Company Bank Statement (mandatory for Corporate Accounts).</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Faq Area */}
          {/* Footer Section Here */}
          <Footer />
        </>
      )}
    </div>
  );
}

export default GeneralFAQ;
